import { BaseState } from '@/store/base-state';
import { PaginationProps, TableOptions } from '@/types';
import { Subpartners, SubpartnerFileUploadData } from '../../../types';

export default class SubpartnersSalesState extends BaseState {
  doc_template_link = '';

  subpartners_sales: Subpartners.SubpartnerSales[] = [];

  pagination_props: PaginationProps = this.create_pagination_props;

  sales_loading = false;

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['date_sale'],
    sortDesc: [true],
  };

  file_upload_details: SubpartnerFileUploadData = {
    fail_rows: null,
    success_rows: null,
    total_rows: null,
  }
}
